import { apiClient } from '../../api/client'
import type {
  GetLastOutstandingActionsDigestRunResponse,
  GetOutstandingActionsDigestRunsResponse,
  GetOutstandingActionsResponse,
} from '../../api/types/outstanding-actions.types'

const OUTSTANDING_ACTIONS_BASE_URL = '/api/outstanding-actions'

// GET /api/outstanding-actions - Work awaiting action that the caller holds permission to action
export const getOutstandingActions = async (): Promise<GetOutstandingActionsResponse> => {
  const response = await apiClient.get<GetOutstandingActionsResponse>(OUTSTANDING_ACTIONS_BASE_URL)
  return response.data
}

// GET /api/outstanding-actions/last-digest-run - When the digest last ran and what it concluded
export const getLastOutstandingActionsDigestRun =
  async (): Promise<GetLastOutstandingActionsDigestRunResponse> => {
    const response = await apiClient.get<GetLastOutstandingActionsDigestRunResponse>(
      `${OUTSTANDING_ACTIONS_BASE_URL}/last-digest-run`,
    )
    return response.data
  }

// GET /api/outstanding-actions/digest-runs - Recent digest runs, newest first
export const getOutstandingActionsDigestRuns =
  async (): Promise<GetOutstandingActionsDigestRunsResponse> => {
    const response = await apiClient.get<GetOutstandingActionsDigestRunsResponse>(
      `${OUTSTANDING_ACTIONS_BASE_URL}/digest-runs`,
    )
    return response.data
  }

// POST /api/outstanding-actions/trigger-digest - Request a digest now
export const triggerOutstandingActionsDigest = async (): Promise<void> => {
  await apiClient.post(`${OUTSTANDING_ACTIONS_BASE_URL}/trigger-digest`)
}
